// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, Component } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import Tooltip from '../Tooltip';

import './Switch.less';

/**
 * `Switch` component.
 */
class Switch extends Component {
    handleChange = event => {
        const { disabled, onChange } = this.props;
        if (!disabled && onChange) {
            onChange(event.target.checked);
        }
    };

    render() {
        const {
            baseClassName,
            className,
            children,
            onChange,
            tooltip,
            intent,
            checked,
            defaultChecked,
            disabled,
            loading,
            ...props
        } = this.props;

        let result = (
            <label
                className={classNames(
                    baseClassName,
                    {
                        [`${baseClassName}--${intent}`]: intent,
                        [`${baseClassName}--loading`]: loading,
                    },
                    className,
                )}
                {...props}
            >
                {children ? <span className={`${baseClassName}__label`}>{children}</span> : null}
                <input
                    type="checkbox"
                    onChange={this.handleChange}
                    checked={checked}
                    defaultChecked={defaultChecked}
                    disabled={disabled || loading}
                />
                <span className={`${baseClassName}__indicator`} />
            </label>
        );

        if (tooltip) {
            result = (
                <Tooltip title={tooltip}>
                    {result}
                </Tooltip>
            );
        }

        return result;
    }
}

Switch.propTypes = {
    /**
     * Determine whether the `Switch` is checked.
     */
    checked: PropTypes.bool,
    /**
     * @ignore
     */
    defaultChecked: PropTypes.bool,
    /**
     * A callback function, can be executed when the checked state is changing.
     */
    onChange: PropTypes.func,
    /**
     * Tooltip for component
     */
    tooltip: PropTypes.any,
    /**
     * Visual intent color to apply to component.
     */
    intent: PropTypes.oneOf(['warning', 'danger']),
    /**
     * Is `Switch` disabled?
     */
    disabled: PropTypes.bool,
    /**
     * Loading indication
     */
    loading: PropTypes.bool,
    /**
     * Label of the `Switch`
     */
    children: PropTypes.node,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

Switch.defaultProps = {
    checked: undefined,
    defaultChecked: undefined,
    onChange: undefined,
    tooltip: undefined,
    intent: undefined,
    disabled: false,
    loading: false,
    children: undefined,
    className: undefined,
    baseClassName: `${CLS_PREFIX}switch`,
};

export default Switch;



// WEBPACK FOOTER //
// ./components/Switch/Switch.js